import { Button, Checkbox, Col, DatePicker, Divider, Form, Input, message, Modal, Row, Select } from "antd"
import useTitularesVehiculoAPI, { TitularVehiculo } from "../../titulares-vehiculo/useTitularesVehiculoAPI";
import locale from "antd/es/date-picker/locale/es_ES";
import { useEffect, useState } from "react";
import moment from "moment-business-days";

export default (props: any) => {
    const [form] = Form.useForm<TitularVehiculo>();
    const apiTitularesVehiculo = useTitularesVehiculoAPI();
    const [aplicarDominio, setAplicarDominio] = useState(false);
    const [aplicarCuit, setAplicarCuit] = useState(false);
    const [soloInfraccion, setSoloInfraccion] = useState(false);

    useEffect(() => {form.resetFields(); form.setFieldValue(undefined, {...props.titular})}, [props.titular, form] );

    useEffect(() => {
        setAplicarCuit(false);
        setAplicarDominio(false);
        setSoloInfraccion(false);
        if (props.titular) {
          try {
            const celularesParsed = props.titular.telefonosCelulares 
              ? JSON.parse(props.titular.telefonosCelulares) 
              : Array(5).fill({ CelularArea: '', CelularTelefono: '', TieneWhatsapp: false });
            
            const fijosParsed = props.titular.telefonosFijo 
              ? JSON.parse(props.titular.telefonosFijo) 
              : Array(5).fill({ Area: '', Telefono: '' });
            
            const emailsParsed = props.titular.emails 
              ? JSON.parse(props.titular.emails) 
              : Array(3).fill({ Email: '' });
    
            form.setFieldsValue({
              ...props.titular,
              TelefonosCelulares: celularesParsed,
              TelefonosFijo: fijosParsed,
              Emails: emailsParsed
            });
          } catch (error) {
            console.error('Error parsing initial data:', error);
          }
        }
      }, [props.titular, form]);

    const handleSave = (data: Partial<TitularVehiculo>) => {
        data.Id = props.titular.id;
        apiTitularesVehiculo.editarVarios(data, soloInfraccion, aplicarDominio, aplicarCuit)
        //apiTitularesVehiculo.editar(data, 1)
            .then(() => {
                message.success('Titular actualizado correctamente');
                props.onCancel(false);
                // Refrescar datos si es necesario
            })
            .catch(error => {
                message.error('Error al actualizar el titular');
            });
    };

    const validateForm = () => {
        form.validateFields()
            .then(values => {
                const dataToSave = {
                    ...values,
                    TelefonosCelulares: JSON.stringify(values.TelefonosCelulares),
                    TelefonosFijo: JSON.stringify(values.TelefonosFijo),
                    Emails: JSON.stringify(values.Emails)
                  };
                  
                //const updatedData = {...props.titular, ...values};
                handleSave(dataToSave);
            })
            .catch(info => {
                console.log('error validando campos de titulares vehiculos', info);
            })
            .finally(

            )
    }

    return(
        <>
        <Modal
            title={'Editando: ' + props.titular?.nombre + ' ' + props.titular?.apellido + ' - ' + props.titular?.id}
            open={props.open}
            onCancel={()=>props.onCancel(false)}
            width={'50%'}
            okText={'Confirmar editar'}
            onOk={validateForm}
            footer={[
                <div key="footer-checkboxes" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <Checkbox checked={aplicarDominio} onChange={(e) => setAplicarDominio(e.target.checked)}>
                            Aplicar a la patente
                        </Checkbox>
                        <Checkbox checked={aplicarCuit} onChange={(e) => setAplicarCuit(e.target.checked)}>
                            Aplicar al CUIT/CUIL
                        </Checkbox>
                        <Checkbox checked={soloInfraccion} onChange={(e) => setSoloInfraccion(e.target.checked)}>
                            Solo esta infracción
                        </Checkbox>
                    </div>
                    <div>
                        <Button key="cancel" onClick={() => props.onCancel(false)}>
                            Cancelar
                        </Button>
                        <Button key="submit" type="primary" onClick={validateForm} disabled={!aplicarDominio && !aplicarCuit && !soloInfraccion}>
                            Confirmar editar
                        </Button>
                    </div>
                    
                </div>
            ]}
        >
            <Form<TitularVehiculo>
                form={form}
                layout="vertical"
                //initialValues={{...props.titular, FechaTransferenciaVehiculo: parseFecha(props.titular?.FechaTransferenciaVehiculo)}}
                initialValues={props.titular}
            >
                <Divider orientation="left" style={{ color: '#1890ff', borderColor: '#1890ff', backgroundColor: '#e6f7ff', padding: '8px 16px', borderRadius: '4px'}}>
                    Datos del vehículo
                </Divider>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="patenteVehiculo"
                            label="Patente del Vehículo"
                            //rules={[{ required: true, message: 'Por favor ingrese la patente' }]}
                            
                        >
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="tipoVehiculo"
                            label="Tipo de Vehículo"
                            //rules={[{ required: true, message: 'Por favor seleccione el tipo' }]}
                        >
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="marcaVehiculo"
                            label="Marca del Vehículo"
                        >
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="modeloVehiculo"
                            label="Modelo del Vehículo"
                        >
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    name="fechaTransferenciaVehiculo"
                    label="Fecha de Transferencia"
                    rules={[{ required: true, message: 'Por favor ingrese la fecha' }]}
                    getValueProps={(value) => ({
                        value: value ? moment(value) : null, // Parsea ISO 8601 directamente
                      })}
                >
                    
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" locale={locale}/>
                </Form.Item>

                <Divider orientation="left" style={{ color: '#1890ff', borderColor: '#1890ff', backgroundColor: '#e6f7ff', padding: '8px 16px', borderRadius: '4px'}}>
                    Datos personales
                </Divider>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="tipoTitular"
                            label="Tipo de Titular"
                            rules={[{ required: true, message: 'Por favor seleccione el tipo' }]}
                        >
                            <Select>
                                <Select.Option value={1}>Empresa</Select.Option>
                                <Select.Option value={2}>Masculino</Select.Option>
                                <Select.Option value={3}>Femenino</Select.Option>
                                <Select.Option value={0}>Otro</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="tipoDocumentoTitular"
                            label="Tipo de Documento"
                            rules={[{ required: true, message: 'Por favor seleccione el tipo' }]}
                        >
                            <Select>
                                <Select.Option value={0}>DNI</Select.Option>
                                <Select.Option value={1}>LC</Select.Option>
                                <Select.Option value={2}>LE</Select.Option>
                                <Select.Option value={3}>CI</Select.Option>
                                <Select.Option value={4}>CUIT</Select.Option>
                                <Select.Option value={5}>PAS</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="documentoTitular"
                            label="Número de Documento"
                            rules={[{ required: true, message: 'Por favor ingrese el documento' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="cuilTitular"
                            label="CUIL/CUIT"
                            rules={[{ required: true, message: 'Por favor ingrese el CUIL/CUIT' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="nombre"
                            label="Nombre"
                            rules={[{ required: true, message: 'Por favor ingrese el nombre' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="apellido"
                            label="Apellido"
                            rules={[{ required: true, message: 'Por favor ingrese el apellido' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left" style={{ color: '#1890ff', borderColor: '#1890ff', backgroundColor: '#e6f7ff', padding: '8px 16px', borderRadius: '4px'}}>
                    Domicilio del titular
                </Divider>

                <Form.Item
                            name="calleTitular"
                            label="Calle"
                            rules={[{ required: true, message: 'Por favor ingrese la calle' }]}
                        >
                            <Input />
                        </Form.Item>

                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name="nroTitular"
                            label="Número"
                            rules={[{ required: true, message: 'Por favor ingrese el número' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="pisoTitular"
                            label="Piso"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="deptoTitular"
                            label="Departamento"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name="localidadTitular"
                            label="Localidad"
                            rules={[{ required: true, message: 'Por favor ingrese la localidad' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="departamentoTitular"
                            label="Departamento"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="provinciaTitular"
                            label="Provincia"
                            rules={[{ required: true, message: 'Por favor ingrese la provincia' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name="codigoPostalTitular"
                            label="Código Postal"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left" style={{ color: '#1890ff', borderColor: '#1890ff', backgroundColor: '#e6f7ff', padding: '8px 16px', borderRadius: '4px'}}>
                    Datos de contacto
                </Divider>

                <h3 style={{'textDecoration':'underline'}}>Teléfonos Celulares</h3>
                <Row gutter={16}>
                {/* Columna izquierda (celulares 1, 3, 5) */}
                <Col span={12}>
                    {[0, 2, 4].map(index => (
                    <>
                    <Row gutter={16} key={`celular-${index}`}>
                        <Col span={8}>
                            <Form.Item
                                label={`Área ${index + 1}`}
                                //name={`telefonosCelulares[${index}]`}
                                name={['TelefonosCelulares', index, 'CelularArea']}
                            >
                                <Input placeholder="Área" />
                            </Form.Item>
                        </Col>
                        <Col span={14}>
                            <Form.Item
                                label={`Número Celular ${index + 1}`}
                                //name={`TelefonosCelulares[${index}].CelularTelefono`}
                                name={['TelefonosCelulares', index, 'CelularTelefono']}
                            >
                                <Input placeholder="Número" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item
                            //name={`TelefonosCelulares[${index}].TieneWhatsapp`}
                            name={['TelefonosCelulares', index, 'TieneWhatsapp']}
                            valuePropName="checked"
                            >
                            <Checkbox>Tiene WhatsApp</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    </>
                    ))}
                </Col>

                {/* Columna derecha (celulares 2, 4) */}
                <Col span={12}>
                    {[1, 3].map(index => (
                    <>
                    <Row gutter={16} key={`celular-${index}`}>
                        <Col span={8}>
                            <Form.Item
                                label={`Área ${index + 1}`}
                                //name={`TelefonosCelulares[${index}].CelularArea`}
                                name={['TelefonosCelulares', index, 'CelularArea']}
                            >
                                <Input placeholder="Área" />
                            </Form.Item>
                        </Col>
                        <Col span={14}>
                            <Form.Item
                                label={`Número Celular ${index + 1}`}
                                //name={`TelefonosCelulares[${index}].CelularTelefono`}
                                name={['TelefonosCelulares', index, 'CelularTelefono']}
                            >
                                <Input placeholder="Número" />
                            </Form.Item>
                        </Col>
                        
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                //name={`TelefonosCelulares[${index}].TieneWhatsapp`}
                                name={['TelefonosCelulares', index, 'TieneWhatsapp']}
                                valuePropName="checked"
                            >
                                <Checkbox>Tiene WhatsApp</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    </>
                    ))}
                </Col>
                </Row>


                 {/* Teléfonos Fijos - 5 en 2 columnas */}
                <h3 style={{'textDecoration':'underline'}}>Teléfonos Fijos</h3>
                <Row gutter={16}>
                    {/* Columna izquierda (fijos 1, 3, 5) */}
                    <Col span={12}>
                    {[0, 2, 4].map(index => (
                        <Row gutter={16} key={`fijo-${index}`}>
                        <Col span={6}>
                            <Form.Item
                            label={`Área ${index + 1}`}
                            //name={`TelefonosFijo[${index}].Area`}
                            name={['TelefonosFijo',index, 'Area']}
                            >
                            <Input placeholder="Área" />
                            </Form.Item>
                        </Col>
                        <Col span={18}>
                            <Form.Item
                            label={`Número Fijo ${index + 1}`}
                            //name={`TelefonosFijo[${index}].Telefono`}
                            name={['TelefonosFijo',index, 'Telefono']}
                            >
                            <Input placeholder="Número" />
                            </Form.Item>
                        </Col>
                        </Row>
                    ))}
                    </Col>

                    {/* Columna derecha (fijos 2, 4) */}
                    <Col span={12}>
                    {[1, 3].map(index => (
                        <Row gutter={16} key={`fijo-${index}`}>
                        <Col span={6}>
                            <Form.Item
                            label={`Área ${index + 1}`}
                            //name={`TelefonosFijo[${index}].Area`}
                            name={['TelefonosFijo',index, 'Area']}
                            >
                            <Input placeholder="Área" />
                            </Form.Item>
                        </Col>
                        <Col span={18}>
                            <Form.Item
                            label={`Número Fijo ${index + 1}`}
                            //name={`TelefonosFijo[${index}].Telefono`}
                            name={['TelefonosFijo',index, 'Telefono']}
                            >
                            <Input placeholder="Número" />
                            </Form.Item>
                        </Col>
                        </Row>
                    ))}
                    </Col>
                </Row>

               {/* Emails - 3 en 2 columnas */}
                <h3 style={{'textDecoration':'underline'}}>Emails</h3>
                <Row gutter={16}>
                    <Col span={12}>
                    <Form.Item
                        label="Email 1"
                        //name="Emails[0].Email"
                        name={['Emails', 0, 'Email']}
                    >
                        <Input placeholder="Email" type="email" />
                    </Form.Item>
                    <Form.Item
                        label="Email 3"
                        //name="Emails[2].Email"
                        name={['Emails', 2, 'Email']}
                    >
                        <Input placeholder="Email" type="email" />
                    </Form.Item>
                    </Col>
                    <Col span={12}>
                    <Form.Item
                        label="Email 2"
                        //name="Emails[1].Email"
                        name={['Emails', 1, 'Email']}
                    >
                        <Input placeholder="Email" type="email" />
                    </Form.Item>
                    </Col>
                </Row>
            </Form>

        </Modal>
        </>
    )
}